import React from "react"
import { datadogRum } from "@datadog/browser-rum"
import { useUserInfo } from "api/hooks"
import { useGetEnvVars } from "api/hooks/enum"

// context
import useAppState from "context/hooks/useAppState"

export default function useDataDog() {
  const { data: user } = useUserInfo()
  const { data: envVars } = useGetEnvVars()
  const { publicEnvVars } = useAppState()

  React.useEffect(() => {
    if (user) {
      datadogRum.setUser(user)
    }
  }, [JSON.stringify(user)])

  React.useEffect(() => {
    if (envVars?.DATADOG_APPLICATION_ID && envVars?.DATADOG_CLIENT_TOKEN) {
      datadogRum.init({
        applicationId: envVars.DATADOG_APPLICATION_ID,
        clientToken: envVars.DATADOG_CLIENT_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: envVars?.DATADOG_APP_SITE,
        service: envVars?.DATADOG_APP_SERVICE,
        env: envVars?.DATADOG_APP_ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: envVars?.DATADOG_SESSION_REPLAY_RATE,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
        tags: [
          `client:${envVars?.CLIENT_NAME}`,
          `env:${envVars?.DATADOG_APP_ENV}`,
          `version:${publicEnvVars?.REACT_APP_PRIME_VERSION}`,
        ],
      })
    }
  }, [envVars?.DATADOG_APPLICATION_ID, envVars?.DATADOG_CLIENT_TOKEN, publicEnvVars?.REACT_APP_PRIME_VERSION])
}
